import { render, staticRenderFns } from "./SelectStyle.vue?vue&type=template&id=bc3dd5d4"
import script from "./SelectStyle.vue?vue&type=script&lang=js"
export * from "./SelectStyle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports